module.exports = __webpack_public_path__ + "static/media/LH-Switch.e54360e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LH-Switch.png
// module id = 712
// module chunks = 0